module.exports = __webpack_public_path__ + "img/zf_3@2x.6cb68d68.png";